import { EncryptJWT, jwtDecrypt } from "jose";

const JWT_SECRET = process.env.JWT_SECRET;

export async function encryptJWT<T extends Record<string, any>>(
  payload: T,
  expirationTime: string | number | Date | null = "1h",
) {
  if (!JWT_SECRET) {
    throw new Error("Attempted to encrypt JWT without JWT_SECRET");
  }

  const secretBuffer = new TextEncoder().encode(JWT_SECRET);

  const jwt = new EncryptJWT(payload)
    .setProtectedHeader({ alg: "dir", enc: "A256CBC-HS512" })
    .setIssuedAt()
    .setIssuer("urn:venturu:venturu")
    .setAudience("urn:venturu:venturu");
  if (expirationTime != null) {
    jwt.setExpirationTime(expirationTime);
  }

  return jwt.encrypt(secretBuffer);
}

export async function decryptJWT<T extends Record<string, any>>(jwt: string) {
  if (!JWT_SECRET) {
    throw new Error("Attempted to decrypt JWT without JWT_SECRET");
  }

  const secretBuffer = new TextEncoder().encode(JWT_SECRET);

  const result = await jwtDecrypt(jwt, secretBuffer, {
    issuer: "urn:venturu:venturu",
    audience: "urn:venturu:venturu",
  });

  return result.payload as T;
}
